import { useState } from 'react'
import { CheckValidation, ValidateFile } from '../../Components/Validations';
import { HideLoder, LogInSchoolID, ShowLoder, YYYYMMDD, getTodayDate, ymdToDate } from '../../JS/Common';
import AlertsComp from '../../Components/AlertsComp';
import { useEffect } from 'react';
import Popup from '../../Components/Popup';
import { ApiCmnHeadersPostCall, ApiGetCDNData } from '../../JS/Connector';
import { log } from '../../JS/Logger';
import CustomReactDatePicker from '../../Components/CustomReactDatePicker';
import { useSelector } from 'react-redux';
import useConfig from '../../Hooks/useConfig';

function SoftwareAddUpdate(props) {
    const { department } = useConfig();
    const initialState = {
        SoftwareName: '',
        PurchasedDate: getTodayDate(new Date()),
        LengthOfLicenses: '',
        EndDate: '',
        Cost: '',
        BuildingsUsed: '',
        Quantity: '',
        Document: null,
        Filename: "",
        Notes: '',
        PdfView: '',
        Grade: '',
        Subject: '',
        DocumentError: "",
        RemoveDocument: false
    };
    const StateData = useSelector((state) => state.authData);
    const [allData, setAllData] = useState(initialState)
    const [NewAlerts, setNewAlerts] = useState("");
    const [loading, setLoading] = useState(false);

    const FlagforAddupadte = props.addupdateFlag
    useEffect(() => {
        if (props.EditData) {
            setAllData({
                SoftwareName: props.EditData.name,
                PurchasedDate: props.EditData.date_purchased,
                LengthOfLicenses: props.EditData.license_length,
                EndDate: props.EditData.license_renewal,
                Cost: props.EditData.cost,
                BuildingsUsed: props.EditData.buildings,
                Quantity: props.EditData.license_qty,
                Notes: props.EditData.notes,
                Filename: props.EditData.document,
                PdfView: props.EditData.document,
                Grade: props.EditData.grade,
                Subject: props.EditData.subject
            });
        }
        if (FlagforAddupadte == 1) {
            setAllData(initialState);
        }
    }, [props.EditData, FlagforAddupadte])
    const handlePdfFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const { isFileValid, validationMsg } = ValidateFile(file, { allowedType: "pdf", maxSizeMB: 5 });
        if (!isFileValid) {
            setAllData({ ...allData, DocumentError: validationMsg, Filename: "", Document: null });
            return;
        }
        setAllData({ ...allData, DocumentError: "", Filename: file.name, Document: file, RemoveDocument: false })
    };

    const handleRemoveDocument = () => {
        setAllData({
            ...allData,
            Document: null,
            Filename: "",
            PdfView: "",
            DocumentError: "",
            RemoveDocument: true
        });
        // Clear the file input
        const fileInput = document.getElementById('UploadFileId');
        if (fileInput) {
            fileInput.value = '';
        }
    };
    const saveSoftware = async (flag) => {
        if (!CheckValidation({ formID: 'AddSoftwareForm' })) return;
        setLoading(true);

        const formdata = new FormData();
        formdata.append('schoolId', LogInSchoolID);
        formdata.append('name', allData.SoftwareName);
        formdata.append('purchaseDate', allData.PurchasedDate);
        formdata.append('licenseLength', allData.LengthOfLicenses);
        formdata.append('licenseRenewal', allData.EndDate);
        formdata.append('cost', allData.Cost);
        formdata.append('buildings', allData.BuildingsUsed);
        formdata.append('licenseQty', allData.Quantity);
        formdata.append('notes', allData.Notes ?? "");
        formdata.append('addUpdateFlag', flag);
        formdata.append('uuid', props.Softwareid);
        if (allData.Document) {
            formdata.append('document', allData.Document);
        }
        formdata.append('grade', allData.Grade ?? "");
        formdata.append('subject', allData.Subject ?? "");
        formdata.append('removeDocument', allData.RemoveDocument ? '1' : '0');

        try {
            const response = await ApiCmnHeadersPostCall(`/software/save`, formdata);
            const result = await JSON.parse(response);
            if (result.response == "success") {
                const msg = flag == 1 ? 'Software Successfully Added!' : 'Software Successfully Updated!';
                setNewAlerts(<AlertsComp show={true} variant="success" msg={msg} />);
                setTimeout(() => {
                    setNewAlerts(<AlertsComp show={false} />);
                    props.ClosePopup();
                    props.GetAllData(null, null, null, false);
                    setAllData(initialState);
                }, 2000);
            } else {
                setNewAlerts(<AlertsComp show={true} variant="danger" msg={result.response} />);
                setTimeout(() => {
                    setNewAlerts(<AlertsComp show={false} />);
                }, 2000);
            }
        } catch (error) {
            log.error('error from addupdatesoftware:', error);
        }
    }
    const openPDFInNewTab = () => {
        if (props.EditData && props.EditData.document) {
            ApiGetCDNData("/" + props.EditData.document, StateData?.Schoolnumber).then((blob) => {
                try {
                    const url = URL.createObjectURL(blob);
                    if (url) window.open(url, "_blank");
                } catch (err) {
                    log.error(err);
                }
            });
        }
    };
    const modalBody = (
        <form id='AddSoftwareForm' className="parent">
            <div className='row justify-content-between'>
                {[
                    { label: 'Name', type: 'text', name: 'SoftwareName', required: true, value: allData.SoftwareName },
                    { label: 'Purchase Date', type: 'date', name: 'PurchasedDate', required: true, value: allData.PurchasedDate, },
                    { label: 'Length of Licenses', type: 'number', name: 'LengthOfLicenses', required: true, value: allData.LengthOfLicenses, min: 0 },
                    { label: 'License Renewal / End Date', type: 'date', name: 'EndDate', required: true, value: allData.EndDate },
                    { label: 'Cost', type: 'number', name: 'Cost', required: true, value: allData.Cost, prefix: '$', min: 0 },
                    { label: 'Buildings Used for', type: 'text', name: 'BuildingsUsed', required: true, value: allData.BuildingsUsed },
                    { label: 'Quantity', type: 'number', name: 'Quantity', required: true, value: allData.Quantity, min: 0 },
                    { label: department || "Grade", type: 'text', name: 'Grade', value: allData.Grade },
                    { label: 'Subject', type: 'text', name: 'Subject', value: allData.Subject },
                ].map((field, index) => (
                    <div key={index} className='col-md-6 pb-3'>
                        <label className='FormLabel'>{field.label}</label> {field.required && <label className='redText'>*</label>}
                        <div className="input-group">
                            {field.prefix && <span className="input-group-text">{field.prefix}</span>}
                            {field.type == "date" ? (
                                <CustomReactDatePicker
                                    inputName={field.name}
                                    isRequired={field.required}

                                    selectedDate={field.value ? ymdToDate(field.value) : null}

                                    onChangeHandler={(date) => setAllData({ ...allData, [field.name]: date ? YYYYMMDD(date) : "" })}
                                    placeholderText="MM-DD-YYYY"
                                />
                            ) : (
                                <input
                                    type={field.type}
                                    autoComplete='off'
                                    className="form-control"
                                    name={field.name}
                                    required={field.required}
                                    value={field.value}
                                    min={field.min}
                                    onChange={(e) => {
                                        if (e.target.value.length > 9 && field.type == 'number') {
                                             setNewAlerts(<AlertsComp show={true} variant="danger" msg="Max 9 digits allowed" />);
                                                                setTimeout(() => {
                                                                    setNewAlerts(<AlertsComp show={false} />)
                                                                }, 1500);
                                            return
                                        }
                                        setAllData({ ...allData, [field.name]: e.target.value })}
                                    }
                                    onKeyDown={(e) => {
                                        if (["e", "E", "+", "-"]?.includes(e?.key) && field.type == 'number') {
                                            e.preventDefault();
                                        }
                                        
                                    }}
                                />
                            )}
                            {field.required && <span className="form-text invalid-feedback">*required</span>}
                        </div>
                    </div>
                ))}
                <div className='col-md-6 pb-3 align-items-center'>
                    <label className='FormLabel'>Add Document</label><br />
                    {props.EditData && props.EditData.document && !allData.RemoveDocument && !allData.Document ?
                        <>
                            <input type="file" id="UploadFileId" name="myFile" accept="application/pdf" onChange={handlePdfFileUpload} />
                            <label className="ImportInventoryBtn col-md-12 cursor-pointer" htmlFor="UploadFileId" style={{ color: "#909091", borderRadius: '10px' }}>
                                Choose File
                            </label>
                            <div className='position-relative border mt-1' style={{ borderRadius: '10px' }}>
                                <label className="ps-2 pe-4 mt-2" style={{ fontWeight: "600", color: 'var(--primary-color)', wordBreak: 'break-all' }}>{allData.PdfView || props.EditData.document}</label>
                                <img src='/images/pdficon.svg' title="Show Software Details" className='px-2 pb-2 cursor-pointer' onClick={openPDFInNewTab} />
                                <div className='position-absolute cursor-pointer d-flex align-items-center justify-content-center
                                 bg-white p-2 border' title="Remove Document" style={{ right: '-12px', top: '-5px', borderRadius: '50%' }} onClick={handleRemoveDocument}>
                                    <img src='/images/RedDelete.svg' className=' ' style={{ width: '12px', height: '12px' }} />
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <input type="file" id="UploadFileId" name="myFile" accept="application/pdf" onChange={handlePdfFileUpload} />
                            <label className="ImportInventoryBtn col-md-12 cursor-pointer" htmlFor="UploadFileId" style={{ color: "#909091", borderRadius: '10px' }}>
                                Choose File
                            </label>
                            {allData.Filename &&
                                <div className='position-relative border mt-1' style={{ borderRadius: '10px' }}>
                                    <label className="ps-2 pe-4 py-2" style={{ fontWeight: "600", color: 'var(--primary-color)', wordBreak: 'break-all' }}>{allData.Filename}</label>
                                    <div className='position-absolute cursor-pointer d-flex align-items-center justify-content-center
                                 bg-white p-2 border' title="Remove Document" style={{ right: '-12px', top: '-5px', borderRadius: '50%' }} onClick={handleRemoveDocument}>
                                        <img src='/images/RedDelete.svg' className=' ' style={{ width: '12px', height: '12px' }} />
                                    </div>
                                </div>
                            }
                            {allData.DocumentError?.trim() != "" && <label className='redText'>{allData.DocumentError}</label>}
                        </>
                    }
                </div>
                <div className='col-md-12 pb-3'>
                    <label className='FormLabel'>Notes</label>
                    <textarea className='form-control notesdata' name='Notes' rows={2} value={allData.Notes}
                        onChange={(e) => setAllData({ ...allData, Notes: e.target.value })}></textarea>
                </div>
            </div>
        </form>
    )
    return (
        <div>
            {NewAlerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <Popup isshow={props.isShow} size={"lg"} title={FlagforAddupadte == 1 ? 'Add New Software' : 'Edit Software'}
                closePopup={(e) => { props.ClosePopup(); setAllData(initialState); }}
                modalBody={modalBody} handleSave={(e) => FlagforAddupadte == 1 ? saveSoftware(1) : saveSoftware(2)} visibleSaveBtn={true}
                btnText={FlagforAddupadte == 1 ? 'Add' : 'Update'} />
        </div>
    )
}

export default SoftwareAddUpdate
